module.exports = __webpack_public_path__ + "static/media/arsalan.250f6a3f.jpg";